var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouriteFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.984 10.723l-4.228 3.69 1.267 5.494a1.5 1.5 0 01-2.235 1.625l-4.792-2.906-4.781 2.906a1.5 1.5 0 01-2.235-1.625l1.265-5.488-4.23-3.696a1.5 1.5 0 01.855-2.63l5.574-.483 2.176-5.19a1.495 1.495 0 012.76 0l2.182 5.19 5.573.482a1.5 1.5 0 01.854 2.631h-.005z"
  })));
}
export default SvgFavouriteFill;